"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableDrillTargets = exports.getIntersectionAttributes = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var uniqBy_1 = tslib_1.__importDefault(require("lodash/fp/uniqBy"));
var flatten_1 = tslib_1.__importDefault(require("lodash/flatten"));
/**
 * @internal
 * Provides the subset of attributes which consist from all attributes before given attribute and attribute itself.
 * @param fromAttribute - attribute to which we want to get relevant intersection's attributes
 * @param attributes - all attributes from the same dimension as fromAttribute
 */
function getIntersectionAttributes(fromAttribute, attributes) {
    var indexOfFromAttribute = attributes.findIndex(function (attribute) {
        // to handle duplicated attributes in the same dimension
        return attribute.attributeHeader.localIdentifier === fromAttribute.attributeHeader.localIdentifier;
    });
    return attributes.slice(0, indexOfFromAttribute + 1);
}
exports.getIntersectionAttributes = getIntersectionAttributes;
function getAvailableDrillAttributes(dv) {
    return flatten_1.default(dv
        .meta()
        .dimensions()
        .map(function (_dimension, index) {
        return dv
            .meta()
            .attributeDescriptorsForDim(index)
            .map(function (attribute, _index, attributes) { return ({
            attribute: attribute,
            intersectionAttributes: getIntersectionAttributes(attribute, attributes),
        }); });
    }));
}
function getAvailableDrillTargets(dv) {
    var attributes = uniqBy_1.default(function (attributeDescriptor) { return attributeDescriptor.attributeHeader.formOf.identifier; }, dv.meta().attributeDescriptors());
    return {
        measures: dv
            .meta()
            .measureDescriptors()
            .map(function (measure) { return ({
            measure: measure,
            attributes: attributes,
        }); }),
        attributes: getAvailableDrillAttributes(dv),
    };
}
exports.getAvailableDrillTargets = getAvailableDrillTargets;
//# sourceMappingURL=availableDrillTargets.js.map